// 📁 /libraries/polygonLibrary.js
import layoutEngine from "./layoutEngine";
import { hexToRgba } from "./RectangleLibrary";
let instances = {}; // key = cellName, value = { layerId: [polygons] }



function getAllPolygons(cellName) {
  const layoutCell   = layoutEngine.getCellByName(cellName);
  const uploadedCell = layoutEngine.getUploadedCell(cellName);

  const fromLayout   = (layoutCell?.elements   || []).filter(e => e.type === 'polygon');
  const fromUploaded = (uploadedCell?.elements || []).filter(e => e.type === 'polygon');

  return [...fromLayout, ...fromUploaded];
}


function setAllInstances(newInstances) {
  instances = JSON.parse(JSON.stringify(newInstances));
}

function ensureCreatedCell(cellName) {
  let cell = layoutEngine.getCellByName(cellName);
  if (!cell) {
    layoutEngine.addCell(cellName);
    cell = layoutEngine.getCellByName(cellName);
  }
  return cell;
}


function addPolygon(cellName, polygon) {
  // 🔥 Ensure writable cell (same as rectangle logic)
  const cell= layoutEngine.getCellByName(cellName);
  // const cell = layoutEngine.ensureCreatedCell(cellName);
  if (!cell) return;

  cell.elements.push({
    ...polygon,
    // id: polygon.id || crypto.randomUUID(),
    type: "polygon"
  });
}


function deletePolygon(cellName, polygonId) {
  const cell = layoutEngine.getCellByName(cellName);
  if (!cell || !cell.elements) return;
  cell.elements = cell.elements.filter(el => !(el.type === "polygon" && el.id === polygonId));
}

function pointInPolygon(point, polygon) {
  let { x, y } = point;
  let inside = false;

  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i][0], yi = polygon[i][1];
    const xj = polygon[j][0], yj = polygon[j][1];

    const intersect = ((yi > y) !== (yj > y)) &&
      (x < ((xj - xi) * (y - yi)) / (yj - yi) + xi);
    if (intersect) inside = !inside;
  }

  return inside;
}
function updateOpacityByLayer(layerId, opacity) {
  // 1) In-memory instances map (agar use ho raha hai)
  for (const cellName in instances) {
    for (const lid in (instances[cellName] || {})) {
      if (lid === layerId) {
        (instances[cellName][lid] || []).forEach(poly => {
          poly.opacity = opacity;
        });
      }
    }
  }

  // 2) Uploaded cells (GDS se aaye)
  const uploadedCells = (layoutEngine.getUploadedCells && layoutEngine.getUploadedCells()) || [];
  uploadedCells.forEach(cell => {
    (cell?.elements || []).forEach(el => {
      if (el.type === 'polygon' && el.layerId === layerId) {
        el.opacity = opacity;
      }
    });
  });

  // 3) Manual/working cells (agar API hai to sab pe chala do)
  // 3) Manual/working cells
const allCells =
  (layoutEngine.getCells && layoutEngine.getCells()) || []; // ⬅️ yeh line


  allCells.forEach(cell => {
    (cell?.elements || []).forEach(el => {
      if (el.type === 'polygon' && el.layerId === layerId) {
        el.opacity = opacity;
      }
    });
  });

  // 4) Safety: agar selected cell known hai to usko bhi touch kar do
  try {
    const selectedCellName = window?.ProjectManager?.getSelectedCell?.();
    if (selectedCellName) {
      const layoutCell = layoutEngine.getCellByName(selectedCellName);
      const uploadedCell = layoutEngine.getUploadedCell(selectedCellName);
      [layoutCell, uploadedCell].forEach(cell => {
        (cell?.elements || []).forEach(el => {
          if (el.type === 'polygon' && el.layerId === layerId) {
            el.opacity = opacity;
          }
        });
      });
    }
  } catch (_) {}

  // 5) Redraw
  if (window.canvasEngine) window.canvasEngine.draw();
}

function updateColorByLayer(layerId, color) {
  // 1) In-memory instances (agar use ho rahe)
  for (const cellName in instances) {
    const byLayer = instances[cellName] || {};
    if (byLayer[layerId]) {
      byLayer[layerId].forEach(poly => {
        poly.stroke = color;
        // fill me alpha deni ho to:
        // poly.fill = hexToRgba(color, 0.3);
        // ya direct solid:
        poly.fill = color;
      });
    }
  }

  // 2) Uploaded cells (GDS se aaye)
  const uploadedCells = (layoutEngine.getUploadedCells && layoutEngine.getUploadedCells()) || [];
  uploadedCells.forEach(cell => {
    (cell?.elements || []).forEach(el => {
      if (el.type === "polygon" && el.layerId === layerId) {
        el.stroke = color;
        // el.fill = hexToRgba(color, 0.3);
        el.fill = color;
      }
    });
  });

  // 3) Working/manual cells
  const allCells = (layoutEngine.getCells && layoutEngine.getCells()) || [];
  allCells.forEach(cell => {
    (cell?.elements || []).forEach(el => {
      if (el.type === "polygon" && el.layerId === layerId) {
        el.stroke = color;
        // el.fill = hexToRgba(color, 0.3);
        el.fill = color;
      }
    });
  });
}

function setAllLock(layerId, lockState) {
  // 1) In-memory polygons
  for (const cellName in this.polygons) {
    if (this.polygons[cellName][layerId]) {
      this.polygons[cellName][layerId].forEach(poly => {
        poly.locked = lockState;
      });
    }
  }

  // 2) Uploaded + created polygons in layoutEngine
  for (const cellName in this.polygons) {
    const layoutCell   = layoutEngine.getCellByName(cellName);
    const uploadedCell = layoutEngine.getUploadedCell(cellName);

    [layoutCell, uploadedCell].forEach(cell => {
      if (cell?.elements?.length) {
        cell.elements.forEach(el => {
          if (el.type === "polygon" && el.layerId === layerId) {
            el.locked = lockState;
          }
        });
      }
    });
  }
}


function setAllPolygons(polygonMap) {
  if (!polygonMap || typeof polygonMap !== 'object') return;

  // Combine created and uploaded cells
  const allCells = [
    ...layoutEngine.getCells(),
    ...layoutEngine.getUploadedCells()
  ];

  for (const cell of allCells) {
    if (!cell || !Array.isArray(cell.elements)) continue;

    // Remove existing polygons
    cell.elements = cell.elements.filter(el => el.type !== 'polygon');

    // Add saved polygons for this cell (match by name)
    if (Array.isArray(polygonMap[cell.name])) {
      cell.elements.push(...polygonMap[cell.name]);
    }
  }
}

function getAllPolygonMap() {
  const map = {};

  // Combine created and uploaded cells
  const allCells = [
    ...layoutEngine.getCells(),
    ...layoutEngine.getUploadedCells()
  ];

  for (const cell of allCells) {
    if (!cell || !Array.isArray(cell.elements)) continue;
    map[cell.name] = cell.elements.filter(el => el.type === "polygon");
  }
  
  return map;
}

function getLayerKey(el) {
  return `${el.layer || el.layerNumber}:${el.datatype || el.datatypeNumber || 0}`;
}

export default {
  getAllPolygons,
  addPolygon,
  deletePolygon,
  pointInPolygon,
  updateOpacityByLayer,
  setAllInstances,
  updateColorByLayer,
  setAllLock,
  getLayerKey,
  getAllPolygonMap,
  ensureCreatedCell,
  setAllPolygons

};
